import { useEffect } from 'react'
import { useLocation } from 'react-router'
import * as routerActions from 'connected-react-router'
import { parse } from 'querystringify'
import { useDispatch } from 'react-redux'

// Actions
import { actions as authActions } from 'modules/auth/actions'
import { actions as profileActions } from 'modules/profile/actions'
import { actions as trackingActions } from 'modules/tracking/actions'

// Components
import { useMaxWidth, IconCloseFat } from '@tracklib/kit'
import OnboardDesktop from 'components/onboard/onboarddesktop'
import OnboardMobile from 'components/onboard/onboardmobile'
import SEO from 'components/base/seo'
import ThemeHelper from 'components/base/themehelper'

// Hooks
import { useProfile } from 'modules/profile/hooks'

import styles from './onboard.css'

const OnboardPage = (): JSX.Element => {
  const dispatch = useDispatch()
  const profile = useProfile()
  const { search } = useLocation()
  const { redirect } = parse(search) as { redirect: string }
  const isSmall = useMaxWidth()

  useEffect(() => {
    dispatch(profileActions.updateProfile({ onboarded: true }, profile.id))
  }, []) // eslint-disable-line

  const onClose = () => {
    dispatch(authActions.onboardingCompleted())
    dispatch(
      routerActions.push({
        pathname: redirect || '/inspiration',
      }),
    )
    dispatch(trackingActions.trackevent('Dismissed onboarding'))
  }

  return (
    <>
      <SEO title="Welcome to Tracklib" />
      <ThemeHelper theme="light" />
      <button onClick={onClose} className={styles.closeButton} datatesting="close_onboarding">
        <IconCloseFat />
      </button>
      {isSmall ? <OnboardMobile redirect={redirect} /> : <OnboardDesktop redirect={redirect} />}
    </>
  )
}

export default OnboardPage
